/**
 *
 * @param {firebase.firestore.DocumentSnapshot} doc
 * @return {*}
 */
export default function dataWithId(doc) {
  return Object.defineProperty(doc.data(), 'id', { value: doc.id });
}
